<ng-template tpToolbarActions toolbarId="ribbon" slot="right">
  <a class="btn btn-primary" routerLink="/users/add">
    <span class="material-icons">add</span>
    Add User
  </a>
  <a class="btn btn-primary" routerLink="/users/groups/add">
    <span class="material-icons">add</span>
    Add Group
  </a>
</ng-template>
<router-outlet />
